import styled from 'styled-components';

const TopNavigation = styled.nav`
  min-width: 100vw;
  height: 60px;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px 0px #0000001a;
  position: relative;
  z-index: 12;
`;

const Logo = styled.img`
  margin-left: 100px;
  max-width: 100px;
  width: auto;
  height: 60px;
  padding: 4px 0;
`;

const Right = styled.div`
  display: flex;
  margin-left: auto;
`;

const StyledHeader = {
  Logo,
  TopNavigation,
  Right,
};

export default StyledHeader;
